module.exports = __webpack_public_path__ + "media/b_bpair_win.ead55329.mp3";